import { ICON_BUTTON_ICONS } from '../../../buttons/IconButton';
import { PROFILER_VIEWS } from '../../../../utils/constants/profilerViews';

// Same three views as the rest of the Profiler, in this tab's own order and with
// its own entry ids. The values come from PROFILER_VIEWS so the stored preference
// ('list' / 'heatmap' / 'chart') stays one vocabulary across every surface.
export const COMPANY_DETAILS_VIEWS_LIST = [
  {
    id: 'CD_COMPARABLES_VIEW_LIST',
    name: 'List',
    value: PROFILER_VIEWS.LIST,
    icon: ICON_BUTTON_ICONS.VIEW_LIST
  },
  {
    id: 'CD_COMPARABLES_HEATMAP',
    name: 'Heatmap',
    value: PROFILER_VIEWS.HEATMAP,
    icon: ICON_BUTTON_ICONS.COLUMNS_GAP
  },
  {
    id: 'CD_COMPARABLES_VIEW_CHART',
    name: 'Chart',
    value: PROFILER_VIEWS.CHART,
    icon: ICON_BUTTON_ICONS.BAR_CHART_LINE
  }
];

/**
 * TD-2838 — the standard view for Comparable companies is the List.
 *
 * This tab renders List, Heatmap and Chart exclusively, so the heatmap does not
 * carry the table underneath it the way it does on search results, saved projects
 * and team feedback (TD-2720 / TD-2733). Taking their heatmap default here hid the
 * comparables table on every result set the user had not explicitly set a view for.
 */
export const DEFAULT_COMPARABLES_VIEW = PROFILER_VIEWS.LIST;
